import { required } from 'react-admin';
/**
 * ## Required Only
 * This field is required with validation
 */
export const requiredOnly = [required()];
